export const detectIsReadOnly = (flowInfo: { isDraft?: boolean }) =>
  flowInfo.isDraft !== undefined && !flowInfo.isDraft;
